<template>
  <v-app>
    <ul class="links">
      <!-- <li>
        <router-link to="/" exact>HOME</router-link>
      </li>
      <li>
        <router-link to="/about">ABOUT</router-link>
      </li>
      <li>
        <router-link to="/login">LOGIN</router-link>
      </li>-->
    </ul>
    <div class="page">
      <transition name="router">
        <router-view />
      </transition>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "App",
  components: {},
  computed: {
    open() {
      return this.$store.getters["topBar/open"];
    }
  },
  methods: {
    setTest: function(msg) {
      alert(msg);
    }
  },
  data: () => ({
    //
  })
};
</script>
<style>
html {
  overflow: hidden;
}
</style>
